import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 13.092C2 7.89 6.061 3.62 11.234 3.22v-.664H9.375a.773.773 0 0 1-.785-.779c0-.436.345-.778.785-.778h5.173c.44 0 .785.342.785.778a.773.773 0 0 1-.785.779h-1.743v.664A9.95 9.95 0 0 1 17.92 5.1l.862-.855-.364-.36a.774.774 0 0 1 0-1.102.79.79 0 0 1 1.11 0l1.82 1.804a.774.774 0 0 1 0 1.1.77.77 0 0 1-.555.228.77.77 0 0 1-.555-.227l-.364-.361-.786.778A9.83 9.83 0 0 1 22 13.092C22 18.558 17.517 23 12 23S2 18.558 2 13.092m10-8.353c-4.655 0-8.448 3.74-8.448 8.371 0 4.613 3.793 8.372 8.448 8.372s8.448-3.759 8.448-8.372S16.655 4.74 12 4.74m0 8.998a.77.77 0 0 1-.785-.76V8.176c0-.436.344-.778.785-.778.44 0 .785.342.785.778v4.005h2.567c.441 0 .786.342.786.779a.773.773 0 0 1-.786.778z"
    }, null, -1)
  ]))]))
}
export default { render: render }